<div class="flex align-items-center gap-2">
  <p-button
    class="btn-new-claim fadein animation-duration-500"
    label="Ver reclamos"
    icon="pi pi-eye"
    routerLink="/main/claims"
    *ngIf="homeView"
  ></p-button>

  <p-button
    class="btn-new-claim fadein animation-duration-500"
    label="Nuevo reclamo laboral"
    icon="pi pi-plus"
    (click)="showDialog()"
  ></p-button>
</div>

<p-dialog
  header="Tipo de reclamo"
  [modal]="true"
  [(visible)]="visible"
  [style]="dialogStyle"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '50vw' }"
  [closable]="true"
  [closeOnEscape]="true"
>
  <div class="claim-type-container">
    <div class="flex justify-content-evenly align-items-center flex-wrap">
      <div
        class="claim-type-option flex flex-column align-items-center justify-content-center p-2 cursor-pointer w-3"
        (click)="selectClaimType('individual')"
      >
        <img
          src="../../../../../../assets/img/main/single.svg"
          class="text-2xl mb-2"
        />
        <span class="claim-label text-center">Reclamo individual</span>
      </div>

      <div
        class="claim-type-option flex flex-column align-items-center justify-content-center p-1 w-3"
        (click)="selectClaimType('plurindividual')"
      >
        <img
          src="../../../../../../assets/img/main/pair.svg"
          class="text-2xl my-3"
        />
        <span class="claim-label text-center">Reclamo plurindividual</span>
      </div>

      <div
        class="claim-type-option flex flex-column align-items-center justify-content-center p-2 cursor-pointer w-3"
        (click)="selectClaimType('colectivo')"
      >
        <img
          src="../../../../../../assets/img/main/group.svg"
          class="text-2xl my-3"
        />
        <span class="claim-label text-center">Reclamo colectivo</span>
      </div>
    </div>
  </div>
</p-dialog>
